export const translationCaEs = {
	globals: {
		title_header: 'RUMI - Registre unificat de maltractament infantil',
		anterior: 'Anterior',
		seguent: 'Següent',
		imprimir: 'Imprimir',
		tancar: 'Tancar',
		inici: 'Inici',
		simulacio: 'Simulació',
		tancar_simulacio: 'Esteu segurs de tancar la finestra?',
		revisar_camps: "Reviseu els següents camps",
		ajuda: "Ajuda"
	},
	home: {
		benvinguda: 'BENVINGUT/UDA al Sistema de suport a la gestió del risc social en la infància i l\'adolescència',
		que_es: 'Què és el sistema?',
		que_preten: 'Què pretén?',
		que_permet: 'Què permet?',
		com_funciona: 'Com funciona?',
		simulacio: 'Simulació'
	},
	inici_simulacio: {
		nom_pestanya: 'Inici simulació',
		ambit_actuacio: 'Àmbit d\'actuació',
		trieu_ambit: 'Trieu l\'àmbit',
		dades_infant_adolescent: 'Dades de l\'infant o adolescent',
		tipus_nasciturus: 'Nasciturus',
		tipus_nado: 'Nadó',
		tipus_infant_adolescent: 'Infant o adolescent',
		sexe: 'Sexe',
		trieu_sexe: 'Trieu el sexe',
		sexe_dona: 'Dona',
		sexe_home: 'Home',
		data_exacta: 'Data exacta',
		edat_estimada: 'Edat estimada',
		trieu_unitat_edat_estimada: 'Trieu unitat edat estimada',
		edat_estimada_anys: 'Anys',
		edat_estimada_mesos: 'Mesos',
		data_naixement: 'Data de naixement',
		dades_nado: 'Dades nadó',
		dades_infant_adolescent_parentesis: 'Dades infant o adolescent (és obligatori indicar la data exacta de naixement o, si no es coneix, la data estimada)',
		ajuda_ambit_actuacio: "Els àmbits estan relacionats amb les 4 àrees professionals des de les quals es poden fer deteccions (Salut, Policia,	Educació i Serveis socials) i, segons l'àmbit triat, el tipus d'observacions que se us ofereixen poden variar. Malgrat que formeu part d'un determinat àmbit d'actuació (per exemple sou de l'àmbit de Salut) pot ser que el vostre rol professional l'efectueu des de l'optica d'un altre àmbit (de Serveis socials, per exemple, si es tracta del/de la treballador/a social d'un hospital); en aquest cas podeu optar per l'opció Tots els àmbits.",
		ajuda_label_nasciturus: "Nasciturus",
		ajuda_label_nado: "Nadó",
		ajuda_label_menor: "Infant/adolescent",
		ajuda_nasciturus: "es tracta dels fetus a l'úter de la mare. Segons sentència del Trubunal Constitucional (STC 53/85) es declara al fetus com un bé jurídicament protegit i exigeix la seva protecció, a tots els efectes civils. Per aquest motiu, malgrat que un fetus no tingui personalitat jurídica pròpia, pot ser objecte d'una protecció específica.",
		ajuda_nado: "nen/a acabat de néixer del qual encara no se'n coneix el nom i només es disposa de les dades de l'hospital on ha nascut, la data de naixement i, de vegades, el nom de la mare. Si se'n coneix el nom i els cognoms caldrà informar-lo com a infant.",
		ajuda_menor: "atès que la Convenció sobre els Drets dels Infants, adoptada per les Nacions Unides el 20 de novembre de 1989, estableix que s'entén per infant tot ésser humà des del seu naixement fins als divuit anys d'edat, llevat que legalment hagi aconseguit abans la majoria d'edat, per economia d'espai trobareu que les observacion seran sempre referents a infant i no a infant/adolescent.",
		ajuda_data_exacta: "quan coneixem amb certesa documental la data de naixement (format dd/mm/aaaa).",
		ajuda_edat_estimada: "quan no es coneix amb certesa la data de naixement s'informarà l'edat de l'infant, o l'edat aproximada si aquest no ens pot dir els anys que té."
	},
	questionari_observacions: {
		nom_pestanya: "Qüestionari d'observacions",
		en_blanc: "Aquesta pantalla surt en blanc perque no hi ha cap 'Observacio' definida per a l'àmbit i l'edat de l'infant o adolescent. Heu de tornar enrera amb el botó 'Anterior' i canviar l'àmbit d'actuació o bé l'edat del menor.",
		noves_observacions_proposades: "Noves observacions proposades",
		afegir_observacio: "Afegir observació",
		observacions_seleccionades: "Observacions seleccionades",
		ajuda_label_blocs: "Qüestionari d'observacions",
		ajuda_label_observacions_disponibles: "Observacions disponibles",
		ajuda_observacions_disponibles: "Són observacions relacionades amb l'àmbit seleccionat i l'edat informada de l'infant/adolescent, i que es poden triar en cas que reflecteixin la situació que heu detectat. Es pot fer una selecció múltiple marcant diverses opcions:",
		ajuda_label_observacions_seleccionades: "Observacions seleccionades",
		ajuda_observacions_seleccionades: "Són observacions que heu triat, ja que són les que defineixen millor la situació que heu detectat. Es pot fer una selecció múltiple marcant diverses opcions:",
		ajuda_label_observacions_proposades: "Noves observacions proposades",
		ajuda_observacions_proposades: "Les observacions que proposeu en aquest espai no es tindran en compte per a calcular el resultat del mòdul. Es tindran en compte per a la millora del sistema.",
		confirm_label_pestanya_anterior: "Esteu segurs?",
		confirm_pestanya_anterior: "Si canvieu l'àmbit i/o l'edat, les 'Observacions' poden canviar, i per tant, no es conservaran les que hagueu seleccionat fins ara. Voleu continuar?",
		alguna_observacio: "És necessari informar almenys una observació d'un dels conjunts disponibles."
	},
	apreciacio_gravetat: {
		nom_pestanya: 'Apreciació de la gravetat',
		conjunt_observacions: "Conjunt d'observacions",
		gravetat: 'Gravetat',
		ajuda_label_lleu: 'Lleu',
		ajuda_lleu: 'la situació es dona amb poca freqüència i amb intensitat baixa.',
		ajuda_label_moderada: 'Moderada',
		ajuda_moderada: 'malgrat que la intensitat o freqüència de la situació no siguin greus, es tenen dubtes raonables sobre la possibilitat que es puguin produir danys més greus en el futur.',
		ajuda_label_greu: 'Greu',
		ajuda_greu: "es dona quan perilla la integritat física, psíquica o emocional de l'infant o adolescent i provoca danys significatius en el seu desenvolupament",
		camps_obligatoris: "Heu de triar la gravetat per a tots els conjunts",		
		trieu_gravetat: 'Trieu la gravetat'
	},
	valoracions_finals: {
		nom_pestanya: 'Valoracions finals'
	},
	altres_observacions: {
		nom_pestanya: 'Altres observacions'
	},
	resultat_risc: {
		nom_pestanya: 'Resultat del mòdul'
	},
	accions: {
		nom_pestanya: 'Accions'
	}
};
